import { render, staticRenderFns } from "./ShortcutOperation.vue?vue&type=template&id=412ed1c0&scoped=true&"
import script from "./ShortcutOperation.vue?vue&type=script&lang=js&"
export * from "./ShortcutOperation.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutOperation.vue?vue&type=style&index=0&id=412ed1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412ed1c0",
  null
  
)

export default component.exports